// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "homepage/static/js/" + chunkId + "." + {"44":"53c3f0d7","133":"b4366d82","581":"ef7e427c","858":"c96649ea","872":"9a356e29","975":"7722bbca"}[chunkId] + ".chunk.js";
};